import { ActionType, Rule } from '@/shared/types/rules';

/**
 * Returns true when at least one active rule assigns an AI agent (brain) to the
 * conversation. Used to gate the webchat preview: if no agent is assigned, the
 * preview would open to a silent, unresponsive chat, so we warn instead.
 *
 * Note: this ignores rule conditions — it only checks that an assigning action
 * exists, not whether the preview user would match that rule's conditions (we
 * can't run condition matching here). A conditioned assigning rule the user
 * doesn't match will therefore suppress the warning and still open a silent
 * preview.
 */
export const hasAssignedAiAgent = (rules: Rule[]): boolean =>
  rules.some(
    (rule) =>
      rule.status === 'active' &&
      rule.actions.some(
        (action) =>
          action.type === ActionType.ASSIGN_BRAIN || action.type === ActionType.ASSIGN_AI_AGENT
      )
  );
